import { render, staticRenderFns } from "./ImportOld.vue?vue&type=template&id=1fb837bd&scoped=true"
import script from "./ImportOld.vue?vue&type=script&lang=js"
export * from "./ImportOld.vue?vue&type=script&lang=js"
import style0 from "./ImportOld.vue?vue&type=style&index=0&id=1fb837bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb837bd",
  null
  
)

export default component.exports